// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"915ce70c","796":"20805807"}[chunkId] + ".chunk.js";
};